import { createContext, Component } from '@wordpress/element';
import against from '../data/against.json';
import inFavor from '../data/inFavor.json';

const UserContext = createContext();

class UserProvider extends Component {
    state = {
        forCat: 0,
        against: against,
        inFavor: inFavor,
        againstOpinion: {},
        forOpinion: {},
        categories: [
            {
                percentage: 37,
                description: 'Friends/family/acquaintances who are gay/lesbian',
                cat: 1
            },
            {
                percentage: 25,
                description: 'Become more tolerant/older/ studied more/more aware',
                cat: 5
            },{
                percentage: 18,
                description: 'World has changed/inevitable/ smore prevalent/doesn’t hurt',
                cat: 2
            },{
                percentage: 18,
                description: 'Freedom to choose/love and happiness',
                cat: 4
            },{
                percentage: 8,
                description: 'Equal rights',
                cat: 3
            },{
                percentage: 5,
                description: 'Morals/religious beliefs/ only God can judge',
                cat: 6
            },{
                percentage: 2,
                description: 'Born that way',
                cat: 7
            },{
                percentage: 6,
                description: 'Other',
                cat: 8
            },
        ]
    };

    geCat = (cat) => {
        const filteredOpinion = inFavor.filter(category => category.cat == cat);
        const len = filteredOpinion.length;
        const randomNumber = Math.floor(Math.random() * ((len -1) - 0 + 1)) + 0;
        this.setState({forOpinion: filteredOpinion[randomNumber], forCat: cat});
    }


    componentDidMount(){
      this.getRandomAgainstOpinion()
      this.geCat(1)
    }

    getRandomAgainstOpinion = () => {
      const max = 11;
      const min = 0;
      const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
      const quote = this.state.against[randomNumber];
      this.setState({againstOpinion: quote})
    }

    getRandomforOpinion = () => {
        const max = inFavor.length - 1;
        const min = 0;
        const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        const quote = this.state.inFavor[randomNumber];
        this.setState({forOpinion: quote, forCat: quote.cat})
    }
    
    getNextAgainstOpinion = () => {
      this.getRandomAgainstOpinion()
    };

    getNextforOpinion = () => {
        this.getRandomforOpinion()
      };

    render() {
        const { children } = this.props;
        const { getNextAgainstOpinion, geCat, getNextforOpinion} = this;

        const {
            forCat,
            against,
            againstOpinion,
            categories,
            forOpinion
        } = this.state;

        return (
            <UserContext.Provider
                value={{
                    forCat,
                    against,
                    againstOpinion,
                    getNextAgainstOpinion,
                    categories,
                    forOpinion,
                    geCat,
                    getNextforOpinion
                }}
            >
                {children}
            </UserContext.Provider>
        );
    }
}

export default UserContext;

export { UserProvider };